import { SQDCEventActionTypeFieldType } from "@/graphql";

export type SQDCButtonModuleOption = {
  value: string;
  labelKey: string;
  severity: "success" | "danger" | "help" | "secondary";
  icon: string;
  class?: string;
};

export function isSQDCButtonModuleType(type?: SQDCEventActionTypeFieldType | null) {
  return (
    type === SQDCEventActionTypeFieldType.VETO ||
    type === SQDCEventActionTypeFieldType.RECOMMENDATION
  );
}

export function getSQDCButtonModuleOptions(
  type?: SQDCEventActionTypeFieldType | null,
): SQDCButtonModuleOption[] {
  if (type === SQDCEventActionTypeFieldType.VETO) {
    return [
      {
        value: "noVeto",
        labelKey: "components.TaskModal.idea.noVeto",
        severity: "success",
        icon: "fas fa-check",
      },
      {
        value: "veto",
        labelKey: "components.TaskModal.idea.veto",
        severity: "danger",
        icon: "fas fa-times",
      },
    ];
  }

  if (type === SQDCEventActionTypeFieldType.RECOMMENDATION) {
    return [
      {
        value: "recommend",
        labelKey: "components.TaskModal.idea.recommend",
        severity: "success",
        icon: "fas fa-check",
      },
      {
        value: "recommendNotPossible",
        labelKey: "components.TaskModal.idea.recommendNotPossible",
        severity: "help",
        icon: "fas fa-check",
      },
      {
        value: "recommendNot",
        labelKey: "components.TaskModal.idea.recommendNot",
        severity: "danger",
        icon: "fas fa-times",
        class: "button-module-field__button--full",
      },
    ];
  }

  return [];
}

export function formatSQDCButtonModuleValue(
  type: SQDCEventActionTypeFieldType | undefined,
  value: unknown,
  t: (key: string) => string,
) {
  const option = getSQDCButtonModuleDisplayOption(type, value);
  return option == null ? value : t(option.labelKey);
}

export function getSQDCButtonModuleDisplayOption(
  type: SQDCEventActionTypeFieldType | undefined,
  value: unknown,
) {
  if (isSQDCButtonModuleType(type) && value === "nothing") {
    return {
      value: "nothing",
      labelKey: "components.TaskModal.idea.nothing",
      severity: "secondary",
      icon: "fas fa-person-circle-question",
    } satisfies SQDCButtonModuleOption;
  }

  return getSQDCButtonModuleOptions(type).find((candidate) => candidate.value === value);
}
